import { Injectable } from "@angular/core";
import {LeagueEventsService, LeagueService} from "@services";
import { BehaviorSubject, Observable } from "rxjs";
import { League, LeagueEvents} from "@model";
import {DataStore} from "./data-store.base";


@Injectable({ providedIn: 'root' })
export class PublicLeagueDataStore extends DataStore{

    protected store = {
        currentLeague: new BehaviorSubject<League | undefined>(undefined),
        leagueEvents: new BehaviorSubject<LeagueEvents | undefined>(undefined)
    };

    constructor(private leagueService: LeagueService,
                private leagueEventsService: LeagueEventsService) {
        super();
    }

    readonly currentLeague$ = this.select<League>('currentLeague');
    readonly leagueEvents$ = this.select<LeagueEvents>('leagueEvents');

    initCurrentLeague(leagueId: number) {
        return this.init('currentLeague',
            () => this.leagueService.fetchLeaguePublic(leagueId));
    }

    initLeagueEvents(leagueId: number)  {
        return this.init('leagueEvents',
            () => this.leagueEventsService.getLeagueEvents(leagueId));
    }

    preloadAll(leagueId: number): Observable<void> {
        return super.preload(
            this.initCurrentLeague(leagueId),
            this.initLeagueEvents(leagueId)
        );
    }

}